import type { Directive } from 'vue';

type KatexWindow = typeof window & { katex?: any };

function cleanMathDelimiters(text: string): string {
  if (!text) return '';
  let result = text.trim();
  // Strip any outer math delimiters if present
  result = result.replace(/^\s*(\\\(|\\\[|\$\$)/, '');
  result = result.replace(/(\\\)|\\\]|\$\$)\s*$/, '');
  return result.trim();
}

function renderOnlyKatexSpans(root: Element): void {
  const w = window as KatexWindow;
  if (typeof window === 'undefined' || !w.katex) return;
  const spans = root.querySelectorAll('span.katex');
  spans.forEach((node) => {
    const element = node as HTMLElement;
    const raw = element.textContent || '';
    const tex = cleanMathDelimiters(raw);
    try {
      w.katex!.render(tex, element, {
        displayMode: false,
        throwOnError: false,
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('KaTeX render error:', error);
    }
  });
}

export const vKatex: Directive = {
  mounted(el: HTMLElement, binding) {
    const html =
      typeof binding.value === 'string' ? binding.value : binding.value?.html;
    if (!html) return;
    el.innerHTML = html;
    renderOnlyKatexSpans(el);
  },
  updated(el: HTMLElement, binding) {
    const html =
      typeof binding.value === 'string' ? binding.value : binding.value?.html;
    if (!html) return;
    el.innerHTML = html;
    renderOnlyKatexSpans(el);
  },
};

export default vKatex;
